export default __webpack_public_path__ + "static/media/Highlord's Dirk.d5bb3fb4.jpg";